import React, { Fragment, useEffect } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import InputMask from "react-input-mask";
import { Input, Label, FormGroup, FormFeedback, Row, Col } from "reactstrap";
const Step1 = ({ userData, setUserData, validationErrors }) => {
  const handleChange = (v, k) => {
    setUserData({ ...userData, [k]: v });
  };

  useEffect(() => {
    //  console.log("userData", userData)
  }, [userData]);

  // handleChange(e.target.value, "report_type")

  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition
          component="div"
          classNames="TabsAnimation"
          appear={true}
          timeout={0}
          enter={false}
          exit={false}
        >
          <div className="form-wizard-content">
            <Row className="g-2">
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail55">First Name</Label>
                  <Input
                    type="text"
                    name="email"
                    id="exampleEmail55"
                    placeholder="Enter First Name"
                    value={userData?.first_name || ""}
                    onChange={(e) => handleChange(e.target.value, "first_name")}
                    invalid={!!validationErrors.first_name}
                  />
                  {validationErrors.first_name && (
                    <FormFeedback>{validationErrors.first_name}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail55">Last Name</Label>
                  <Input
                    type="text"
                    name="email"
                    id="exampleEmail55"
                    placeholder="Enter Last Name"
                    value={userData?.last_name || ""}
                    onChange={(e) => handleChange(e.target.value, "last_name")}
                    invalid={!!validationErrors.last_name}
                  />
                  {validationErrors.last_name && (
                    <FormFeedback>{validationErrors.last_name}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="examplePassword22">Email</Label>
                  <Input
                    readOnly
                    type="email"
                    name="password"
                    id="examplePassword22"
                    placeholder="Enter First Email"
                    value={userData?.email || ""}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail55">Email 2</Label>
                  <Input
                    type="text"
                    name="email"
                    id="exampleEmail55"
                    placeholder="Enter Second Email"
                    value={userData?.email2 || ""}
                    onChange={(e) => handleChange(e.target.value, "email2")}
                    invalid={!!validationErrors.email2}
                  />
                  {validationErrors.email2 && (
                    <FormFeedback>{validationErrors.email2}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="examplePassword22">Company Name</Label>
                  <Input
                    type="text"
                    name="company"
                    id="company"
                    placeholder="Enter Company Name"
                    value={userData?.company_name || ""}
                    onChange={(e) =>
                      handleChange(e.target.value, "company_name")
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail55">Phone</Label>
                  {/* <Input type="text" name="email" id="exampleEmail55" placeholder="Enter Phone Number"
                                        value={userData?.phone || ''} onChange={(e) => handleChange(e.target.value, "phone")} /> */}
                  <InputMask
                    className="form-control"
                    mask="(999) 999-9999"
                    placeholder="(123) 456-7890"
                    maskChar={null}
                    value={userData?.phone || ""}
                    onChange={(e) => handleChange(e.target.value, "phone")}
                  />
                  <div
                    style={
                      validationErrors.phone
                        ? { display: "block" }
                        : { display: "none" }
                    }
                    className="invalid-feedback"
                  >
                    {validationErrors.phone}
                  </div>
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail55">Address</Label>
                  <Input
                    type="text"
                    name="email"
                    id="exampleEmail55"
                    placeholder="Enter Address"
                    value={userData?.address || ""}
                    onChange={(e) => handleChange(e.target.value, "address")}
                    invalid={!!validationErrors.address}
                  />
                  {validationErrors.address && (
                    <FormFeedback>{validationErrors.address}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
                 <Col md={6}>
                <FormGroup>
                  <Label for="exampleCity">City</Label>
                  <Input
                    type="text"
                    name="city"
                    id="exampleCity"
                    placeholder="Enter City"
                    value={userData?.city || ""}
                    onChange={(e) => handleChange(e.target.value, "city")}
                    invalid={!!validationErrors.city}
                  />
                  {validationErrors.city && (
                    <FormFeedback>{validationErrors.city}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleState">State</Label>
                  <Input
                    type="select"
                    name="state"
                    id="exampleState"
                    placeholder="Enter State"
                    value={userData?.state || ""}
                    onChange={(e) => handleChange(e.target.value, "state")}
                    invalid={!!validationErrors.state}
                  >
                    <option value="">Select State</option>
                    <option value="ak">Alaska</option>
                    <option value="al">Alabama</option>
                    <option value="ar">Arkansas</option>
                    <option value="as">American Samoa</option>
                    <option value="az">Arizona</option>
                    <option value="ca">California</option>
                    <option value="co">Colorado</option>
                    <option value="ct">Connecticut</option>
                    <option value="dc">District of Columbia</option>
                    <option value="de">Delaware</option>
                    <option value="fl">Florida</option>
                    <option value="fm">Federated States of Micronesia</option>
                    <option value="ga">Georgia</option>
                    <option value="gu">Guam</option>
                    <option value="hi">Hawaii</option>
                    <option value="ia">Iowa</option>
                    <option value="id">Idaho</option>
                    <option value="il">Illinois</option>
                    <option value="in">Indiana</option>
                    <option value="ks">Kansas</option>
                    <option value="ky">Kentucky</option>
                    <option value="la">Louisiana</option>
                    <option value="ma">Massachusetts</option>
                    <option value="md">Maryland</option>
                    <option value="me">Maine</option>
                    <option value="mh">Marshall Islands</option>
                    <option value="mi">Michigan</option>
                    <option value="mn">Minnesota</option>
                    <option value="mo">Missouri</option>
                    <option value="mp">Northern Mariana Islands</option>
                    <option value="ms">Mississippi</option>
                    <option value="mt">Montana</option>
                    <option value="nc">North Carolina</option>
                    <option value="nd">North Dakota</option>
                    <option value="ne">Nebraska</option>
                    <option value="nh">New Hampshire</option>
                    <option value="nj">New Jersey</option>
                    <option value="nm">New Mexico</option>
                    <option value="nv">Nevada</option>
                    <option value="ny">New York</option>
                    <option value="oh">Ohio</option>
                    <option value="ok">Oklahoma</option>
                    <option value="or">Oregon</option>
                    <option value="pa">Pennsylvania</option>
                    <option value="pr">Puerto Rico</option>
                    <option value="ri">Rhode Island</option>
                    <option value="pw">Palau</option>
                    <option value="sc">South Carolina</option>
                    <option value="sd">South Dakota</option>
                    <option value="tx">Texas</option>
                    <option value="tn">Tennessee</option>
                    <option value="ut">Utah</option>
                    <option value="va">Virginia</option>
                    <option value="vi">Virgin Islands</option>
                    <option value="vt">Vermont</option>
                    <option value="wa">Washington</option>
                    <option value="wi">Wisconsin</option>
                    <option value="wv">West Virginia</option>
                    <option value="wy">Wyoming</option>
                    <option value="aa">Armed Forces Americas</option>
                    <option value="ae">Armed Forces Africa</option>
                    <option value="ap">Armed Forces Pacific</option>
                  </Input>
                  {validationErrors.state && (
                    <FormFeedback>{validationErrors.state}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleZip">Zip</Label>
                  <Input
                    type="number"
                    name="zip"
                    id="exampleZip"
                    placeholder="Enter Zip"
                    value={userData?.zip || ""}
                    onChange={(e) => handleChange(e.target.value, "zip")}
                    invalid={!!validationErrors.zip}
                  />
                  {validationErrors.zip && (
                    <FormFeedback>{validationErrors.zip}</FormFeedback>
                  )}
                </FormGroup>
              </Col>
            </Row>

            {/* <FormGroup>
                            <Label for="exampleAddress">Address</Label>
                            <Input type="text" name="address" id="exampleAddress" placeholder="First Address"
                                value={userData?.address || ''} onChange={(e) => handleChange(e.target.value, "address")} />
                        </FormGroup> */}
            {/* <FormGroup>
                            <Label for="exampleAddress2">Address 2</Label>
                            <Input type="text" name="address2" id="exampleAddress2" placeholder="Second Address" />
                        </FormGroup> */}

          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
};
export default Step1;
